







import Vue from 'vue'

import types from '../../store/types'
import {Shape} from '../../interface'

import EditorImage from './Image.vue'

export default Vue.extend({

  components: {
    EditorImage
  },

  data(): {
    imageWrap: HTMLElement | null
  } {
    return {
      imageWrap: null
    }
  },

  computed: {
    scale: {
      get(): number {
        return this.$store.state.Shape.scale
      },
      set(scale: number): void {
        this.$store.commit(types.mutations.SHAPE_SCALE, scale)
      }
    },
    styleObject(): any {
      const shapeIndex: number = this.$store.state.Current.shape
      const shapeList: Shape[] = this.$store.state.Shape.list

      if (! shapeList[shapeIndex] || ! this.imageWrap) {
        return {}
      }
      const shapeInfo: Shape = shapeList[shapeIndex]

      this.scale = this.imageWrap.offsetWidth / shapeInfo.width

      return {
        'width': shapeInfo.width + 'px',
        'height': shapeInfo.height + 'px',
        'transform': 'scale(' + this.scale + ')',
        'mask-image': 'url(' + shapeInfo.image + ')',
        '-webkit-mask-image': 'url(' + shapeInfo.image + ')'
      }
    }
  },

  mounted() {
    this.imageWrap = document.getElementById('image-wrap')
  }

})
